import { evaluateExpression, isTruthy } from '@ayumia/core/expressions';
/**
 * Condition d'une vue (`condition`, `visible_when` ; ADR-048 §8) évaluée par l'évaluateur unique du
 * Core, sur `$record` et `$context` seulement. C'est de la présentation : une condition fausse
 * masque une action ou un champ, elle ne protège rien. Une condition qui ne s'évalue pas vaut
 * « non affiché » : une erreur ne révèle jamais un contrôle par défaut.
 */
export function evaluateViewCondition(condition, scope, functions) {
    if (condition === undefined)
        return true;
    try {
        return isTruthy(evaluateExpression(condition, { record: scope.record ?? null, context: scope.context ?? {} }, functions === undefined ? {} : { functions }));
    }
    catch {
        return false;
    }
}
/**
 * Valeurs pré-remplies d'une action de vue (`inputs`, ADR-064 §3), évaluées sur `$record` et
 * `$context` par l'évaluateur unique du Core. Une aide de saisie : le serveur valide et autorise la
 * commande. Une valeur qui ne s'évalue pas, ou vaut `null`, n'est pas pré-remplie : l'utilisateur
 * la saisit.
 */
export function resolveActionInputs(inputs, scope, functions) {
    const values = {};
    for (const [field, expression] of Object.entries(inputs ?? {})) {
        try {
            const value = evaluateExpression(expression, { record: scope.record ?? null, context: scope.context ?? {} }, functions === undefined ? {} : { functions });
            if (value !== null && value !== undefined)
                values[field] = value;
        }
        catch {
            // Non pré-remplie : la saisie reste ouverte.
        }
    }
    return values;
}
/**
 * Condition d'un formulaire de gabarit (`visible_when`, `required_when`, `evidence.when` ; ADR-058
 * §2, ADR-064 §5), sur `$answers`. Aide de saisie : le serveur relit le formulaire à sa version
 * exacte et tranche. Une condition qui ne s'évalue pas vaut « faux ».
 */
export function evaluateFormCondition(condition, answers, functions) {
    if (condition === undefined)
        return true;
    try {
        return isTruthy(evaluateExpression(condition, { answers }, functions === undefined ? {} : { functions }));
    }
    catch {
        return false;
    }
}
/**
 * Condition d'une ligne d'un onglet `lines` (`applies_when`, ADR-133 §4), sur `$line`, `$record` et
 * `$context`. Présentation : le serveur revalide la décision. Une condition qui ne s'évalue pas vaut
 * « faux ».
 */
export function evaluateLineCondition(condition, scope, functions) {
    if (condition === undefined)
        return true;
    try {
        return isTruthy(evaluateExpression(condition, { line: scope.line ?? null, record: scope.record ?? null, context: scope.context ?? {} }, functions === undefined ? {} : { functions }));
    }
    catch {
        return false;
    }
}
/** Paramètres d'une requête tirés d'une ligne (`row_detail.parameters`, ADR-133 §3) ; une valeur absente n'est pas transmise. */
export function resolveLineValues(values, scope, functions) {
    const out = {};
    for (const [name, expression] of Object.entries(values)) {
        try {
            const value = evaluateExpression(expression, { line: scope.line ?? null, record: scope.record ?? null, context: scope.context ?? {} }, functions === undefined ? {} : { functions });
            if (value !== null && value !== undefined)
                out[name] = value;
        }
        catch {
            // Absente : la requête dira ce qui manque.
        }
    }
    return out;
}
//# sourceMappingURL=conditions.js.map